import React, { useEffect, useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import styled from 'styled-components';
import * as Toasts from '../Toastify';
import Column from './column';
import { useSelector } from 'react-redux';

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const DragAndDrop = (props) => {
    const [data, setData] = useState({});
    const originalOrderList = useSelector(store => store?.matchingCandidateInfo?.shiftReleaseOderList);
    useEffect(() => {
        if (props.data) {
            //  console.log('props--------->', props.data);
            setData(props.data);
        }
    }, [props.data])

    // console.log(data);
    const deleteContent = (selecteddata, index, columnId) => {
        //console.log(data);
        // console.log(index);
        const orginalOrder = [];
        const orderIdes = originalOrderList.map(item => item?.jobShiftReleaseOrderId);
        // console.log(orderIdes);
        //console.log(selecteddata, index, columnId);
        const col2 = data.columns[columnId];
        const col1 = data.columns['column-1'];
        const oldTaskIds = Array.from(col1.orderIds);
        const newTaskIds = Array.from(col2.orderIds);
        oldTaskIds.push(parseInt(newTaskIds[index]));
        // orderIdes.map(item => orginalOrder.push(oldTaskIds[parseInt(item)]))
        orderIdes.map(item => oldTaskIds.map(val => {
            if (parseInt(item) === val) {
                orginalOrder.push(parseInt(item))
            }
        }))
        // console.log('------', oldTaskIds);
        // console.log(orginalOrder);
        //console.log(typeof newTaskIds[index])
        if (newTaskIds[index] === '1') {
            props.closeShiftRelease();
            Toasts.error('Please Unselect To select candidate on Main page');
            return;
        }
        newTaskIds.splice(index, 1);
        // console.log(newTaskIds);
        const newcol2 = {
            ...col2,
            orderIds: newTaskIds,
        };
        const newcol1 = {
            ...col1,
            orderIds: orginalOrder,
        };
        const newState = {
            ...data,
            columns: {
                ...data.columns,
                'column-1': newcol1,
                [columnId]: newcol2,
            },
        };
        props.getOrderedData(newState)
        //console.log(newState);
        //setData(newState);
    }

    const onDragStart = start => {
        const homeIndex = data.columnOrder.indexOf(start.source.droppableId);
        // console.log(homeIndex);
        setData({
            ...data,
            homeIndex,
        });
    };

    const onDragEnd = result => {
        // console.log(result);
        setData({
            ...data,
            homeIndex: null,
        });

        const { destination, source, draggableId } = result;
        if (!destination) {
            return;
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }
        const start = data.columns[source.droppableId];
        const finish = data.columns[destination.droppableId];
        //console.log(start, finish)
        if (start === finish) {
            if (finish.id === 'column-1') {
                return;
            }
            const newTaskIds = Array.from(start.orderIds);
            newTaskIds.splice(source.index, 1);
            newTaskIds.splice(destination.index, 0, draggableId);
            const newColumn = {
                ...start,
                orderIds: newTaskIds,
            };

            const newState = {
                ...data,
                columns: {
                    ...data.columns,
                    [newColumn.id]: newColumn,
                },
            };
            //  console.log(newState);
            props.getOrderedData(newState)
            // setData(newState);
            return;
        }

        if (draggableId === '1') {
            props.closeShiftRelease();
            Toasts.error('Please Select To select candidate on Main page');
            return;
        }

        // Moving from one list to another
        const startOrderIds = Array.from(start.orderIds);
        startOrderIds.splice(source.index, 1);
        const newStart = {
            ...start,
            orderIds: startOrderIds,
        };
        const finishOrderIds = Array.from(finish.orderIds);
        finishOrderIds.splice(destination.index, 0, draggableId);
        const newFinish = {
            ...finish,
            orderIds: finishOrderIds,
        };
        const newState = {
            ...data,
            columns: {
                ...data.columns,
                [newStart.id]: newStart,
                [newFinish.id]: newFinish,
            },
        };
        // console.log(newState);
        props.getOrderedData(newState)
        //setData(newState);
    }
    return (
        <Container>
            <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
                {data?.columnOrder?.map((columnId, index) => {
                    const column = data?.columns[columnId];
                    const arrVal = column?.orderIds?.map(ordrId => data?.orderList[ordrId]);
                    const isDropDisabled = index < data?.homeIndex;
                    return <>
                        <Column key={column.id}
                            column={column} value={arrVal}
                            columnId={columnId}
                            deleteContent={deleteContent}
                            isDropDisabled={isDropDisabled}
                        />
                        {index === 0 && <span className='d-flex align-items-center ms-3'><i className="fa fa-long-arrow-right fa-3x"></i></span>}
                    </>
                })}
            </DragDropContext>
        </Container>
    )
}

export default DragAndDrop;